var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v(_vm._s(_vm.collection.title))]),_c('ul',{staticClass:"collection"},_vm._l((_vm.collection.routes.filter(r => r.is === 'Products')),function(route,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":_vm._f("joinPath")([_vm.routePath, route.path])}},[_vm._v(" "+_vm._s(route.id)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }